import { create } from "zustand";
import { EmailDraftSavingActions, EmailDraftSavingState } from "./types";

export const useEmailDraftSavingStore = create<
    EmailDraftSavingState & EmailDraftSavingActions
>((set, get) => ({
    cancelRefs: [],
    closingSessionIds: new Set<string>(),

    register: (sessionId: string, cancelFn: () => void) =>
        set((state) => {
            const filtered = state.cancelRefs.filter(
                (ref) => ref.sessionId !== sessionId
            );

            return {
                cancelRefs: [...filtered, { sessionId, cancelFn }],
            };
        }),

    unregister: (sessionId: string) =>
        set((state) => ({
            cancelRefs: state.cancelRefs.filter(
                (ref) => ref.sessionId !== sessionId
            ),
        })),

    cancel: (sessionId: string) => {
        const ref = get().cancelRefs.find((r) => r.sessionId === sessionId);
        
        if (ref) {
            ref.cancelFn();
        }
    },

    markAsClosing: (sessionId: string) =>
        set((state) => {
            const newSet = new Set(state.closingSessionIds);
            newSet.add(sessionId);

            return { closingSessionIds: newSet };
        }),

    isClosing: (sessionId: string) => {
        return get().closingSessionIds.has(sessionId);
    },

    clearClosing: (sessionId: string) =>
        set((state) => {
            const newSet = new Set(state.closingSessionIds);
            newSet.delete(sessionId);

            return { closingSessionIds: newSet };
        }),
}));